import script from "./CharactersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CharactersComponent.vue?vue&type=script&setup=true&lang=js"

import "./CharactersComponent.vue?vue&type=style&index=0&id=233eae39&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233eae39"]])

export default __exports__